/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Vue } from 'vue-property-decorator';
import router from '@/router';
import CreditAgreementsReadPop from './AgreementsPop.vue';
import type { OpenParams, CreditAgreementsReadPopProps } from './types';
import { CreditAgreementsReadPopEvents } from './event-names';

/**
 * CreditAgreementsReadPop 组件的适配器类
 * 将 Vue 组件实例包装成单例模式
 */
class CreditAgreementsReadPopAdapter {
  private wrapperInstance: Vue;

  private resolve?: () => void;

  private reject?: () => void;

  constructor() {
    // 保存回调引用，用于在 render 函数中使用
    const onUpdateShow = this.handleUpdateShow.bind(this);
    const onAgreementConfirmed = this.handleAgreementConfirmed.bind(this);
    const onClose = this.handleClose.bind(this);
    const onCancel = this.handleCancel.bind(this);

    // 创建包装器 Vue 实例，用于管理响应式状态
    this.wrapperInstance = new Vue({
      router,
      data() {
        return {
          show: false,
          commodityIdList: [] as number[],
        };
      },
      render(h) {
        const vm = this as Vue & CreditAgreementsReadPopProps;
        return h(CreditAgreementsReadPop, {
          props: {
            show: vm.show,
            commodityIdList: vm.commodityIdList,
          },
          on: {
            [CreditAgreementsReadPopEvents.UPDATE_SHOW]: onUpdateShow,
            [CreditAgreementsReadPopEvents.AGREEMENT_CONFIRMED]: onAgreementConfirmed,
            [CreditAgreementsReadPopEvents.CLOSE]: onClose,
            [CreditAgreementsReadPopEvents.CANCEL]: onCancel,
          },
        });
      },
    });

    // 挂载到 DOM
    const container = document.createElement('div');
    document.body.appendChild(container);
    this.wrapperInstance.$mount(container);
  }

  /**
   * 处理弹窗显示状态更新
   */
  private handleUpdateShow(value: boolean): void {
    const vm = this.wrapperInstance.$data as { show: boolean };
    vm.show = value;
  }

  /**
   * 处理协议阅读完成事件
   */
  private handleAgreementConfirmed(): void {
    this.close();
    if (this.resolve) {
      this.resolve();
    }
  }

  /**
   * 处理关闭事件
   */
  private handleClose(): void {
    this.close();
    if (this.reject) {
      this.reject();
    }
  }

  /**
   * 处理取消事件
   */
  private handleCancel(): void {
    this.close();
    if (this.reject) {
      this.reject();
    }
  }

  /**
   * 打开弹窗
   */
  public open(params: OpenParams): Promise<void> {
    // 使用 Vue 的响应式数据来控制显示
    const vm = this.wrapperInstance.$data as CreditAgreementsReadPopProps;

    this.wrapperInstance.$set(vm, 'commodityIdList', params.commodityIdList || []);
    this.wrapperInstance.$set(vm, 'show', true);

    return new Promise<void>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  /**
   * 关闭弹窗
   */
  public close(): void {
    // 使用 Vue 的响应式数据来控制隐藏
    const vm = this.wrapperInstance.$data as { show: boolean };
    vm.show = false;
  }
}

let instance: CreditAgreementsReadPopAdapter;

/**
 * 单例模式打开弹窗
 */
export const creditAgreementsReadPop = {
  /**
   * 打开弹窗
   * @param params 打开参数
   * @returns Promise，resolve 时返回结果
   */
  open(params: OpenParams): Promise<void> {
    if (!instance) {
      instance = new CreditAgreementsReadPopAdapter();
    }

    return instance.open(params);
  },

  /**
   * 关闭弹窗
   */
  close(): void {
    if (instance) {
      instance.close();
    }
  },
};
